import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { Modal } from 'semantic-ui-react';

// Global Types
import { AppState } from 'services/types';

// Global Actions
// @ts-ignore
import { createPerson } from 'services/people/actions';
// @ts-ignore
import { updateQueryString } from 'services/router/actions';

// Global Workspaces
// @ts-ignore
import { ErrorBoundary } from 'workspaces/redux-error-boundary';
import {
    makeSelectQueryStringBooleanValue
    // @ts-ignore
} from 'workspaces/react-router-selectors';

// Global Components
// @ts-ignore
import CurrentSeasonInProgressGate from 'components/CurrentSeasonInProgressGate';
// @ts-ignore
import ErrorBoundaryAlert from 'components/ErrorBoundaryAlert';
import RoleGate from 'components/RoleGate';
import { Roles } from 'components/RoleGate/types';

interface OwnProps {
    param: string;
    children: React.ReactElement;
    size?: 'tiny' | 'small' | 'mini' | 'large' | 'fullscreen';
    classname?: string;
    requiredRoles: Roles[];
    ignoreSeason?: boolean;
    namespace?: string;
}

interface ConnectedProps {
    isOpen?: boolean;
}

interface DispatchProps {
    updateQueryString: Function;
}

export type Props = ConnectedProps & DispatchProps & OwnProps;

/**
 * A modal that is only visible for those with permission
 */
export class RoleModalComponent extends React.PureComponent<Props> {
    handleClose = (): void => {
        const { param, ...props } = this.props;
        props.updateQueryString({
            [param]: undefined
        });
    };

    render(): React.ReactElement {
        const {
            isOpen,
            children,
            size = 'tiny',
            classname = '',
            requiredRoles,
            ignoreSeason = false,
            namespace = 'RoleModal'
        } = this.props;

        const baseComponent = (
            <RoleGate requiredRoles={requiredRoles}>
                <Modal
                    size={size}
                    open={isOpen}
                    centered={false}
                    onClose={this.handleClose}
                    closeIcon
                    className={classname}
                >
                    <ErrorBoundary
                        namespace={namespace}
                        FallbackComponent={<ErrorBoundaryAlert />}
                    >
                        {children}
                    </ErrorBoundary>
                </Modal>
            </RoleGate>
        );

        return ignoreSeason ? (
            baseComponent
        ) : (
            <CurrentSeasonInProgressGate>
                {baseComponent}
            </CurrentSeasonInProgressGate>
        );
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    isOpen: (state: any, props: any): boolean =>
        makeSelectQueryStringBooleanValue(props.param)(state, props)
});

export default connect(mapStateToProps, {
    createPerson,
    updateQueryString
})(RoleModalComponent);
